/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { PurchaseOrderStatusBadge_OrderNodeFragmentDoc } from '../../features/purchase-orders/PurchaseOrderStatusBadge.generated.js';
import { PurchaseOrderTitle_OrderNodeFragmentDoc } from '../../features/purchase-orders/PurchaseOrderTitle.generated.js';
import { PurchaseOrderListItem_OrderNodeFragmentDoc } from '../../features/purchase-orders/PurchaseOrderListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentsPurchaseOrdersQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  filterStatus?: Types.InputMaybe<Types.OrderStatus>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DocumentsPurchaseOrdersQuery = { orders: { __typename: 'MissingCapabilities' } | { __typename: 'OrderConnection', totalCount: number, edges: Array<{ __typename: 'OrderEdge', node: { __typename: 'OrderNode', id: string, number: string, createdAt: any, orderedDate?: any | null, clientName: string, supplierName?: string | null, projectId: string, projectNumber: string } }> } };

export type DocumentsPurchaseOrders_OrderNodeFragment = { __typename: 'OrderNode', id: string, number: string, createdAt: any, orderedDate?: any | null, clientName: string, supplierName?: string | null, projectId: string, projectNumber: string };

export const DocumentsPurchaseOrders_OrderNodeFragmentDoc = gql`
    fragment DocumentsPurchaseOrders_OrderNode on OrderNode {
  id
  number
  createdAt
  orderedDate
  clientName
  supplierName
  projectId
  projectNumber
}
    `;
export const DocumentsPurchaseOrdersDocument = gql`
    query DocumentsPurchaseOrders($limit: Int!, $offset: Int!, $filterStatus: OrderStatus, $searchTerm: String) {
  orders(
    limit: $limit
    offset: $offset
    sorting: [{column: createdAt, direction: desc}]
    filterStatus: $filterStatus
    searchTerm: $searchTerm
  ) {
    ... on OrderConnection {
      totalCount
      edges {
        node {
          id
          ...DocumentsPurchaseOrders_OrderNode
          ...PurchaseOrderStatusBadge_OrderNode
          ...PurchaseOrderTitle_OrderNode
          ...PurchaseOrderListItem_OrderNode
        }
      }
    }
  }
}
    ${DocumentsPurchaseOrders_OrderNodeFragmentDoc}
${PurchaseOrderStatusBadge_OrderNodeFragmentDoc}
${PurchaseOrderTitle_OrderNodeFragmentDoc}
${PurchaseOrderListItem_OrderNodeFragmentDoc}`;

/**
 * __useDocumentsPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useDocumentsPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsPurchaseOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filterStatus: // value for 'filterStatus'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useDocumentsPurchaseOrdersQuery(baseOptions: Apollo.QueryHookOptions<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables> & ({ variables: DocumentsPurchaseOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables>(DocumentsPurchaseOrdersDocument, options);
      }
export function useDocumentsPurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables>(DocumentsPurchaseOrdersDocument, options);
        }
export function useDocumentsPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables>(DocumentsPurchaseOrdersDocument, options);
        }
export type DocumentsPurchaseOrdersQueryHookResult = ReturnType<typeof useDocumentsPurchaseOrdersQuery>;
export type DocumentsPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useDocumentsPurchaseOrdersLazyQuery>;
export type DocumentsPurchaseOrdersSuspenseQueryHookResult = ReturnType<typeof useDocumentsPurchaseOrdersSuspenseQuery>;
export type DocumentsPurchaseOrdersQueryResult = Apollo.QueryResult<DocumentsPurchaseOrdersQuery, DocumentsPurchaseOrdersQueryVariables>;